import { ArdoqId, WidgetTypes } from '@ardoq/api-types';
import { TrackEvent, WidgetsCommands } from '../../types';
import { EditModeHeaderWidgetProps } from '../renderTypes';
import { isEmpty } from 'lodash';
import { DashboardBuilderHeaderWidgetProps } from '../types';
import { Maybe } from '@ardoq/common-helpers';
import { DashboardTrackingEventsNames } from '../../tracking';

// For view mode header widgets we can just use the widgetData directly as props

export const getEditModeHeaderWidgetProps = ({
  widgetData: { _id, layout, content, viewValidationErrors },
  isSaving,
  isInLinkDashboardFiltersMode,
  selectedWidgetId,
  commands,
  trackEvent,
}: {
  widgetData: DashboardBuilderHeaderWidgetProps;
  isInLinkDashboardFiltersMode: boolean;
  selectedWidgetId: Maybe<ArdoqId>;
  isSaving: boolean;
  trackEvent: TrackEvent;
  commands: WidgetsCommands;
}): EditModeHeaderWidgetProps => ({
  _id,
  layout,
  content,
  isInLinkDashboardFiltersMode,
  isSelected: _id === selectedWidgetId,
  hasError: !isEmpty(viewValidationErrors?.[0]),
  commands: {
    selectWidget: () => commands.selectWidget(_id),
    copyWidget: () => {
      trackEvent(
        DashboardTrackingEventsNames.DUPLICATED_HEADER_IN_DASHBOARD_BUILDER
      );
      commands.copyWidget(_id);
    },
    deleteWidget: () => {
      trackEvent(
        DashboardTrackingEventsNames.DELETED_NOTE_IN_DASHBOARD_BUILDER
      );
      commands.deleteWidget(_id, WidgetTypes.HEADER);
    },
  },
  isSaving,
});
